import React, { useState, useEffect, useRef } from 'react';

import { trackPromise } from 'react-promise-tracker';
import {
    Modal,
    Avatar,
    Form,
    Input,
    message
} from 'antd';
import pencil from '../../../../assets/icons/pencil.svg'
import { InfoCircleOutlined, EditOutlined } from '@ant-design/icons'
import services from '../../../../services'
import { criarPermissao, obterPermissaoInfo, editarPermissao } from '../../../../services/http/permissaoServico'
import PermissoesUsuarios from './PermissoesUsuarios'
import PermissoesPastas from './PermissoesPastas'

import './styles.scss';

const PermissaoForm = ({ listarPermissao, idPermissaoEdicao }) => {
    const { IdUser, login, IsAdmin } = services.storage.getUser();
    const [usuarios, setUsuariosPermissao] = useState([]);
    const [usuariosRemovidos, setUsuariosRemovidos] = useState([]);
    const [pastasRemovidas, setPastasRemovidas] = useState([]);
    const [novasPastasAdicionadasEdicao, setNovasPastasAdicionadasEdicao] = useState([]);
    const [pastas, setPastasPermissao] = useState([]);
    const [incluirSubPastas, setIncluirSubPastas] = useState(false);
    const [naoConfiguravel, setNaoConfiguravel] = useState(false);
    const [form] = Form.useForm();

    const onSubmit = (value) => {

        if (value.titulo == undefined) {
            message.info('Informe o título');
            return;
        }

        if (usuarios.length === 0 && pastas.length === 0) {
            message.info('Informe ao menos um usuário ou pasta');
            return;
        }

        if (idPermissaoEdicao == null) {

            let data = {
                nomePermissao: value.titulo,
                descricao: value.descricao,
                idPastas: ObterIdsPastasSelecionadas(),
                idUsuario: ObterIdsUsuariosSelecionados(),
                incluirSubPastasArquivos: incluirSubPastas
            }

            trackPromise(
                criarPermissao(data)
                    .then(res => {
                        if (!res.fail) {
                            message.success('Permissao criada com sucesso');
                            listarPermissao();
                        }
                    }).catch(error => {
                        message.success(error);
                    })
            )
        } else {
            let data = {
                nomePermissao: value.titulo,
                descricao: value.descricao,
                IdsPastas: ObterIdsPastasSelecionadas(),
                IdsUsuarios: ObterIdsUsuariosSelecionados(),
                IdsPastasRemovidas: ObterIdsPastasRemovidos(),
                IdsUsuariosRemovidos: ObterIdsUsuariosRemovidos(),
                incluirSubPastasArquivos: incluirSubPastas
            }
            trackPromise(
                editarPermissao(idPermissaoEdicao, data)
                    .then(res => {
                        if (!res.fail) {
                            message.success('Permissão atualizada com sucesso');
                            listarPermissao();
                        }
                    }).catch(error => {
                        message.success(error);
                    })
            )
        }

    }

    const ObterIdsUsuariosSelecionados = () => {
        let listaIdsUsuarios = [];
        usuarios.forEach(element => {
            listaIdsUsuarios.push(element.id)
        });

        return listaIdsUsuarios;
    }

    const ObterIdsUsuariosRemovidos = () => {
        let listaIdsUsuariosRemovidos = [];
        usuariosRemovidos.forEach(element => {
            listaIdsUsuariosRemovidos.push(element.id)
        });

        return listaIdsUsuariosRemovidos;
    }

    const ObterIdsPastasRemovidos = () => {
        let listaIdsPastasRemovidas = [];
        pastasRemovidas.forEach(element => {
            listaIdsPastasRemovidas.push(element.id)
        });

        return listaIdsPastasRemovidas;
    }

    const ObterIdsPastasSelecionadas = () => {
        let listaIdsPastasSelecionadas = [];
        pastas.forEach(element => {
            listaIdsPastasSelecionadas.push(element.id)
        });

        return listaIdsPastasSelecionadas;
    }

    const listaUsuariosComPermissao = () => {
        trackPromise(
            obterPermissaoInfo(idPermissaoEdicao)
                .then(res => {
                    if (!res.fail && res.data) {
                        setUsuariosPermissao(res.data?.usuarios);
                        setPastasPermissao(res.data?.pastas);
                        form.setFieldsValue({
                            ['titulo']: res.data?.permissao,
                            ['descricao']: res.data?.descricao
                        });
                        setNaoConfiguravel(res.data?.naoConfiguravel);
                    }
                })
                .catch(error => {
                    console.error(error);
                })
        )
    }

    useEffect(() => {
        if (idPermissaoEdicao != undefined && idPermissaoEdicao != null) {
            listaUsuariosComPermissao();
        }
    }, [idPermissaoEdicao])

    return (
        <div className='col-md-9 col-sm-9 col-xl-9' >
            <Form
                form={form}
                layout='vertical'
                onFinish={onSubmit}
                className='mt-3'
            >
                <div className='row' style={{ borderBottom: '1px solid #898989' }}>
                    <div style={{ padding: '0px' }} className='col-md-12 col-sm-12 col-xl-12'>
                        <Form.Item
                            name="titulo"
                        >
                            <Input prefix={<Avatar className='avatar-custom' style={{ background: '#0042DD', marginRight: '0.2rem', color: '#FFFFFF' }}>
                                <span style={{ color: '#000'}} >.</span></Avatar>} role={require} placeholder='Nova Permissão' className='titulo-perm forumario-permissao p-0' />
                        </Form.Item>
                    </div>
                </div>

                <div className='mt-3 mb-3 titulosPermissoesNotificacoes'>Informações</div>


                <Form.Item
                    className='label-item-t'
                    name="descricao"
                    label="Breve descrição"
                    style={{ marginLeft: '0px' }}
                >
                    <Input role={require} placeholder='Escreva aqui uma breve descrição da permissão' className='input-usuario' />

                </Form.Item>

                <PermissoesUsuarios setUsuariosRemovidos={setUsuariosRemovidos} usuariosComPermissao={usuarios} setUsuariosPermissao={setUsuariosPermissao} idPermissaoEdicao={idPermissaoEdicao}/>

                <PermissoesPastas
                    setNovasPastasAdicionadasEdicao={setNovasPastasAdicionadasEdicao}
                    setPastasRemovidas={setPastasRemovidas}
                    pastasComPermissao={pastas}
                    incluirSubPastas={incluirSubPastas}
                    setIncluirSubPastas={setIncluirSubPastas}
                    setPastasPermissao={setPastasPermissao}
                    naoConfiguravel={naoConfiguravel} />

                <div className='d-flex justify-content-center mt-5'>
                    <button type="submit" className='btn-aplicarNotForm mb-5'>
                        {idPermissaoEdicao ? 'Aplicar' : 'Enviar'}
                    </button>
                </div>
            </Form>
        </div >)
}

export default PermissaoForm;